export const dashboardConstants = {
   
    COUNT_REQUEST: 'DASHBOARD_COUNT_REQUEST',
    COUNT_SUCCESS: 'DASHBOARD_COUNT_SUCCESS',
    COUNT_FAILURE: 'DASHBOARD_COUNT_FAILURE',
    
  
};
